import Swiper from 'swiper';

let galleries = document.querySelectorAll('.js-gallery-inline');

galleries.forEach(gallery => makeGallery(gallery));


function makeGallery(gallery) {
	
	let thumbs = new Swiper(gallery.querySelector('.js-gallery-inline-thumbs'), {
		speed: 500,
		freeMode: true,
		slidesPerView: 'auto',
		// effect: 'fade',
		spaceBetween: 12,
		loop: false,
		autoHeight: false,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
		navigation: {
			prevEl: gallery.querySelector('.gallery-inline-thumbs__btn_prev'),
			nextEl: gallery.querySelector('.gallery-inline-thumbs__btn_next')
		},
		// grabCursor: true
	});
	
	let view = new Swiper(gallery.querySelector('.js-gallery-inline-view'), {
		speed: 500,
		freeMode: true,
		freeModeSticky: true,
		freeModeMomentum:0.2,
		// effect: 'fade',
		spaceBetween: 64,
		loop: false,
		autoHeight: false,
		navigation: {
			prevEl: gallery.querySelector('.gallery-inline-view__btn_prev'),
			nextEl: gallery.querySelector('.gallery-inline-view__btn_next')
		},
		grabCursor: true,
		thumbs: {
			swiper: thumbs,
		},
	});
}
